import { Theme } from '@mui/material/styles';

export const MuiOutlinedInput = (theme: Theme) => ({
  styleOverrides: {
    root: {
      '&:hover': {
        border: `1px solid ${theme.palette.tags.greyDark}`,
      },
      '&.Mui-focused': {
        border: `2px solid ${theme.palette.inputField.focused}`,
      },
      '& label.Mui-focused': {
        color: theme.palette.inputField.focused,
      },
      '&.Mui-error': {
        border: `1px solid ${theme.palette.border.red}`,
        '&.Mui-focused': {
          border: `2px solid ${theme.palette.border.red}`,
        },
      },
    },
  },
});
